import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba7ca336"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = ["onDrop", "onDragstart"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Uploadimg = _resolveComponent("Uploadimg")!
  const _component_TEditor = _resolveComponent("TEditor")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Uploadvideo = _resolveComponent("Uploadvideo")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "ruleFormRef",
      model: _ctx.ruleForm,
      rules: _ctx.rules,
      "label-width": "120px",
      class: "demo-ruleForm"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "标题",
          prop: "title"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.ruleForm.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.title) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "关于我们类型",
          prop: "aboutUsType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.ruleForm.aboutUsType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.aboutUsType) = $event)),
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutUsType, (v, k) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: v.enumName,
                    value: k,
                    key: k
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "封面" }, {
          default: _withCtx(() => [
            _createVNode(_component_Uploadimg, {
              image: _ctx.ruleForm.fileName?_ctx.fileName+_ctx.ruleForm.fileName:'',
              onOnSuccess: _ctx.onImgSuccess
            }, null, 8, ["image", "onOnSuccess"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "描述",
          prop: "description"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TEditor, {
              modelValue: _ctx.ruleForm.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.description) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "排序",
          prop: "sortNum"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: _ctx.ruleForm.sortNum,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.sortNum) = $event)),
              min: 0,
              max: 30
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ruleForm.others, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onDragover: _cache[4] || (_cache[4] = ($event: any) => (_ctx.allowDrop($event))),
            draggable: "true",
            onDrop: ($event: any) => (_ctx.drop($event, index)),
            onDragstart: ($event: any) => (_ctx.drag($event, index)),
            class: "drop"
          }, [
            _createVNode(_component_el_divider, { "content-position": "left" }, {
              default: _withCtx(() => [
                _createTextVNode("其他信息" + _toDisplayString(index+1), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, {
              label: "标题",
              prop: "cores"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: item.title,
                  "onUpdate:modelValue": ($event: any) => ((item.title) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                (index != 0)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "iconfont icon-cha re",
                      onClick: ($event: any) => (_ctx.removeList(index))
                    }, null, 8, _hoisted_3))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: item.description,
                  "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                  type: "textarea"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            (_ctx.ruleForm.aboutUsType!='ABOUT_US_VIDEO')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "封面"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Uploadimg, {
                      image: item.fileName,
                      onClick: ($event: any) => (_ctx.getIndex(index)),
                      onOnSuccess: _ctx.onSuccess
                    }, null, 8, ["image", "onClick", "onOnSuccess"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (_ctx.ruleForm.aboutUsType=='ABOUT_US_VIDEO')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "视频",
                  prop: "content"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Uploadvideo, {
                      onOnSuccess: _ctx.fileSuccess,
                      files: item.fileName,
                      onClick: ($event: any) => (_ctx.getIndex(index))
                    }, null, 8, ["onOnSuccess", "files", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ], 40, _hoisted_2))
        }), 128)),
        _createVNode(_component_el_form_item, { label: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.addOther
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}